function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = require("react");

var styled = require("styled-components").default;

var Link = require("@patternplate/component-link").Link;

var Icon = require("@patternplate/component-icon").Icon;

var Text = require("@patternplate/component-text").Text;

var tag = require("tag-hoc").default; // import Outside from "./outside";


var SearchFieldSlot = function SearchFieldSlot(props) {
  return props.children;
};

var PassThroughSlot = function PassThroughSlot(props) {
  return props.children;
};

var NOOP = function NOOP() {};

function Search(props) {
  var children = React.Children.toArray(props.children);
  var searchResultList = children.filter(function (item) {
    return item.type === StyledResultList;
  });
  var searchPreviewChildren = children.filter(function (item) {
    return item.type === StyledResultPreview;
  });
  var searchField = children.filter(function (item) {
    return item.type === SearchFieldSlot;
  });
  var passThrough = children.filter(function (item) {
    return item.type === PassThroughSlot;
  });
  return React.createElement(StyledFormBox, {
    enabled: props.enabled,
    inline: props.inline,
    onClickOutside: props.inline || !props.enabled ? NOOP : props.onClickOutside,
    onClick: props.inline && !props.enabled ? props.onFocus : NOOP,
    value: props.value
  }, React.createElement(StyledForm, {
    onSubmit: props.onSubmit,
    method: "GET"
  }, React.createElement(StyledSearchFieldBox, {
    onClick: props.inline ? props.onClick : NOOP
  }, searchField, passThrough, React.createElement(HiddenSubmit, null), React.createElement(SearchLegend, props.legend)), React.createElement(StyledResults, null, searchResultList, searchPreviewChildren)));
}

var SEARCH_HEIGHT = "55vh";
var SEARCH_FIELD_HEIGHT = "80px";
var SEARCH_LEGEND_HEIGHT = "30px";
var StyledFormBox = styled(tag(["onClickOutside", "enabled"])("div")).withConfig({
  displayName: "search__StyledFormBox"
})(["width:100%;height:100%;border-radius:10px;pointer-events:all;overflow:hidden;margin:", ";opacity:", ";"], function (props) {
  return props.inline ? 'calc(12.5vh - 30px) 0 60px 0' : '0';
}, function (props) {
  return props.inline && props.enabled ? '0' : '1';
});
var StyledForm = styled.form.withConfig({
  displayName: "search__StyledForm"
})(["display:flex;flex-direction:column;position:relative;z-index:2;width:100%;max-height:", ";", ""], SEARCH_HEIGHT, function (props) {
  return withTint(props);
});
var StyledSearchFieldBox = styled.div.withConfig({
  displayName: "search__StyledSearchFieldBox"
})(["position:relative;z-index:1;flex:0 0 auto;"]);
var StyledResults = styled.div.withConfig({
  displayName: "search__StyledResults"
})(["position:relative;z-index:1;flex:1 1 auto;display:flex;flex-direction:row;max-height:calc(", " - ", " - ", ");"], SEARCH_HEIGHT, SEARCH_FIELD_HEIGHT, SEARCH_LEGEND_HEIGHT);
var StyledResultPreview = styled.div.withConfig({
  displayName: "search__StyledResultPreview"
})(["flex:1 1 60%;overflow:scroll;-webkit-touch-scroll:auto;"]);
var StyledResultList = styled.div.withConfig({
  displayName: "search__StyledResultList"
})(["flex:1 0 40%;overflow:scroll;-webkit-touch-scroll:auto;border-right:1px solid ", ";"], function (props) {
  return props.theme.colors.border;
});
var StyledResultHeading = styled(Text).withConfig({
  displayName: "search__StyledResultHeading"
})(["box-sizing:border-box;position:-webkit-sticky;position:sticky;z-index:1;top:0;margin:0;font-size:14px;padding:3px 15px;border-width:1px 0;border-style:solid;border-color:", ";color:", ";background:", ";"], function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.theme.colors.background;
});
var StyledIcon = styled(tag(["active"])(Icon)).withConfig({
  displayName: "search__StyledIcon"
})(["flex:0 0 auto;fill:", ";margin-right:10px;"], function (props) {
  return props.active ? props.theme.colors.active : props.theme.colors.color;
});
var Linkable = tag(["active"])(Link);
var StyledPreviewLink = styled(Linkable).withConfig({
  displayName: "search__StyledPreviewLink"
})(["position:absolute;right:15px;top:50%;transform:translateY(-50%);text-decoration:none;color:", ";opacity:0;&:hover{color:", ";text-decoration:underline;}"], function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.color;
});
var StyledResultLink = styled(Linkable).withConfig({
  displayName: "search__StyledResultLink"
})(["display:flex;align-items:center;width:100%;padding:10px 15px;&:link,&:visited,&:active{color:", ";text-decoration:none;}"], function (props) {
  return props.active ? props.theme.colors.active : props.theme.colors.color;
});
var StyledResultLinkText = styled(Text).withConfig({
  displayName: "search__StyledResultLinkText"
})(["line-height:20px;color:", ";text-decoration:none;"], function (props) {
  return props.active ? props.theme.colors.active : props.theme.colors.color;
});
var StyledResult = styled.div.withConfig({
  displayName: "search__StyledResult"
})(["position:relative;box-sizing:border-box;display:flex;align-items:center;&:hover{mask-image:linear-gradient( to left,rgba(0,0,0,0) 75px,rgba(0,0,0,1) 125px);-webkit-mask-image:linear-gradient( to left,rgba(0,0,0,0) 75px,rgba(0,0,0,1) 125px);}&:hover{opacity:1;}"]);

var SearchResult =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchResult, _React$Component);

  function SearchResult() {
    var _ref;

    var _this;

    _classCallCheck(this, SearchResult);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_ref = SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call.apply(_ref, [this].concat(args)));
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchResult, [{
    key: "getRef",
    value: function getRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(next) {
      if (next.active && this.ref) {
        this.props.onScrollRequest({
          target: this.ref
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement(StyledResult, {
        ref: this.getRef,
        active: props.active,
        title: "Navigation to pattern ".concat(props.name),
        "data-id": props.id
      }, React.createElement(StyledResultLink, {
        active: props.active,
        href: props.href,
        query: {
          "search-enabled": false
        }
      }, React.createElement(StyledResultLinkText, {
        active: props.active,
        size: "l"
      }, props.name)), React.createElement(StyledPreviewLink, {
        active: props.active,
        query: {
          "search-preview": props.index
        }
      }, React.createElement(Text, {
        active: props.active,
        size: "s"
      }, "\"Preview\"")));
    }
  }]);

  return SearchResult;
}(React.Component);

SearchResult.defaultProps = {
  onScrollRequest: function onScrollRequest() {}
};
var HiddenSubmit = styled.input.attrs({
  type: 'submit'
}).withConfig({
  displayName: "search__HiddenSubmit"
})(["display:none;"]);
var StyledClose = styled(Link).withConfig({
  displayName: "search__StyledClose"
})(["font-size:0;line-height:0;"]);
var StyledCloseIcon = styled(Icon).withConfig({
  displayName: "search__StyledCloseIcon"
})(["fill:", ";"], function (props) {
  return props.theme.colors.color;
});

function Close(props) {
  var verb = props.clears ? "Clear" : "Close";
  var query = props.clears ? {
    search: null
  } : {
    "search-enabled": null
  };
  var symbol = "close"; // TODO: Add and use icon for clearing

  return React.createElement(StyledClose, {
    query: query,
    title: "".concat(verb, " search ").concat(props.shortcut.toString())
  }, React.createElement(StyledCloseIcon, {
    size: "m",
    symbol: symbol
  }), verb);
}

var StyledSearchLegend = styled.div.withConfig({
  displayName: "search__StyledSearchLegend"
})(["display:flex;align-items:center;height:30px;position:relative;box-sizing:border-box;width:100%;padding:0 15px;border:1px solid ", ";color:", ";", ";"], function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return withTint(props);
});
var StyledSearchLegendBox = styled.div.withConfig({
  displayName: "search__StyledSearchLegendBox"
})(["display:flex;overflow:scroll;-webkit-overflow-scrolling:touch;width:100%;position:relative;z-index:1;::-webkit-scrollbar{display:none;}"]);
var StyledField = styled(Text).withConfig({
  displayName: "search__StyledField"
})(["padding:0 10px;color:", ";&:first-child{padding-left:0;}}"], function (props) {
  return props.theme.colors.color;
});
var StyledLegendName = styled(StyledField).withConfig({
  displayName: "search__StyledLegendName"
})(["padding-right:20px;font-weight:bold;color:", ";position:relative;z-index:1;"], function (props) {
  return props.theme.colors.color;
});
var StyledFieldLink = styled(Link).withConfig({
  displayName: "search__StyledFieldLink"
})(["white-space:nowrap;&:link,&:active,&:visited,&:hover{color:", ""], function (props) {
  return props.theme.colors.color;
});

function SearchLegend(props) {
  return React.createElement(StyledSearchLegend, {
    className: props.className
  }, props.name && React.createElement(StyledLegendName, null, props.name), React.createElement(StyledSearchLegendBox, null, (props.items || []).map(function (l) {
    switch (l.type) {
      case "field":
      default:
        return React.createElement(StyledField, {
          key: l.key
        }, React.createElement(StyledFieldLink, {
          title: l.description,
          query: {
            search: "".concat(l.value)
          }
        }, l.key));
    }
  })));
}

function withTint(props) {
  return "\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\tz-index: 0;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground: ".concat(props.theme.colors.background, ";\n\t\t\topacity: 0.975;\n\t\t}\n\t");
}

module.exports.default = Search;
module.exports.SearchResult = SearchResult;
module.exports.SearchResultList = StyledResultList;
module.exports.SearchResultHeading = StyledResultHeading;
module.exports.SearchResultPreview = StyledResultPreview;
module.exports.SearchFieldSlot = SearchFieldSlot;
module.exports.PassThroughSlot = PassThroughSlot;
module.exports.Close = Close;
//# sourceMappingURL=index.js.map